import { useEffect, useRef, useState } from "react";
import { Box, Button, FormControl, MenuItem, Select, TextField } from "@mui/material";
import { useFormik } from "formik";
import colorConfigs from "../../../../configs/colorConfigs";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


const ContactDetailsForm = (props: any) => {

    const { title, currentStep, defaultData, handleBack, handleNext, iComponetTranslate } = props;
    const [initialData, setInitialData] = useState({
        firstname: "",
        lastname: "",
        jobPosition: "",
        phone: null,
        language: "",
        email:""
    });
    const review = useRef(false);

    const languages = [
        {
            "id": 1,
            "language_name": "Spanish",
            "language_code": "es"
        },
        {
            "id": 2,
            "language_name": "Finnish",
            "language_code": "fi"
        },
        {
            "id": 3,
            "language_name": "English",
            "language_code": "gb"
        },
        {
            "id": 4,
            "language_name": "Italian",
            "language_code": "it"
        },
        {
            "id": 5,
            "language_name": "Sweden",
            "language_code": "se"
        }
    ]

    useEffect(() => {
        if(defaultData){
        if (Object.keys(defaultData).length > 0) {
            setInitialData(defaultData)
        }
    }
    }, [defaultData])

    const t = (name: string) => {
        const ifExist: any = iComponetTranslate.filter((item: any) => item.label === name);
        if (ifExist.length > 0) {
            return ifExist[0].value ? ifExist[0].value : `No translate found (${ifExist[0].label})`;
        }
        return `No key found (${name})`;
    }

    const handleSendParentData = (formValues: any) => {
        switch (currentStep) {
            case 4:
                return handleNext({ "commercialContact": formValues, "review": review.current  })
            case 5:
                return handleNext({ "technicalContact": formValues, "review": review.current  })
            default:
                break;
        }
    }

    const handleReviewButtonClick = () => {
        review.current = true;
        formik.submitForm();
    };

    const formik = useFormik({
        initialValues: {
            firstname: initialData.firstname,
            lastname: initialData.lastname,
            jobPosition: initialData.jobPosition,
            phone: initialData.phone,
            language: initialData.language,
            email: initialData.email
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            handleSendParentData(values)
        }
    }
    )
    return (
        <>
            <Box sx={{ width: "100%", padding: 1 }}>
                <Box className="fw-600" sx={{ color: "#012445", fontSize: "26px;", lineHeight: "normal", marginBottom: "40px", justifyContent: "flex-start", display: "flex" }}>
                    {t(title)}
                </Box>
                <form onSubmit={formik.handleSubmit}>

                    <Box sx={{ display: 'grid', gridTemplateRows: 'repeat(6, 1fr)', rowGap: 2 }} >
                        <Box sx={{ width: "100%" }}>
                            <div className="customer-form-lable">
                                {t("Firstname")}
                            </div>
                            <FormControl sx={{ width: "100%" }}>
                                <TextField
                                    className="cm-customer-filed"
                                    name="firstname"
                                    variant="outlined"
                                    value={formik.values.firstname}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder={`${t("Firstname")}`}
                                />
                            </FormControl>
                            {formik.errors.firstname && formik.touched.firstname && <p className="cm-form-error">{formik.errors.firstname}</p>}
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <div className="customer-form-lable">
                                {t("Lastname")}
                            </div>
                            <FormControl sx={{ width: "100%" }}>
                                <TextField
                                    className="cm-customer-filed"
                                    name="lastname"
                                    variant="outlined"
                                    value={formik.values.lastname}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder={`${t("Lastname")}`}
                                />
                            </FormControl>
                            {formik.errors.lastname && formik.touched.lastname && <p className="cm-form-error">{formik.errors.lastname}</p>}
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <div className="customer-form-lable">
                                {t("JobPosition")}
                            </div>
                            <FormControl sx={{ width: "100%" }}>
                                <TextField
                                    className="cm-customer-filed"
                                    name="jobPosition"
                                    variant="outlined"
                                    value={formik.values.jobPosition}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder={`${t("JobPosition")}`}
                                />
                            </FormControl>
                            {formik.errors.jobPosition && formik.touched.jobPosition && <p className="cm-form-error">{formik.errors.jobPosition}</p>}
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <div className="customer-form-lable">
                                {t("Phone")}
                            </div>
                            <FormControl sx={{ width: "100%" }}>
                                <TextField
                                    className="cm-customer-filed"
                                    name="phone"
                                    variant="outlined"
                                    value={formik.values.phone}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder={`${t("Phone")}`}
                                />
                            </FormControl>
                            {formik.errors.phone && formik.touched.phone && <p className="cm-form-error">{formik.errors.phone}</p>}
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <div className="customer-form-lable">
                                {t("Email")}
                            </div>
                            <FormControl sx={{ width: "100%" }}>
                                <TextField
                                    className="cm-customer-filed"
                                    name="email"
                                    variant="outlined"
                                    size="small"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    placeholder={`${t("Email")}`}
                                />
                            </FormControl>
                            {formik.errors.email && formik.touched.email && <p className="cm-form-error">{formik.errors.email}</p>}
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <div className="customer-form-lable">
                                {t("Language")}
                            </div>
                            <FormControl sx={{ width: "100%" }}>
                                <Select
                                    className='form-select-pad'
                                    name="language"
                                    label=""
                                    value={formik.values.language}
                                    onChange={formik.handleChange}
                                >
                                    {languages.map((il)=>{
                                        return(
                                            <MenuItem value={il.language_code}>{il.language_name}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                            {formik.errors.language && formik.touched.language && <p className="cm-form-error">{formik.errors.language}</p>}
                        </Box>
                    </Box>
                    <Box display={"flex"} justifyContent={"space-between"} sx={{marginTop:2}}>
                        {currentStep !== 1 && <Button
                            onClick={handleBack}
                            variant="contained"
                            className="cm-btn-style"
                            sx={{
                                display: "flex",
                                justifyContent: "end",
                                color: colorConfigs.btnColor.colorDarkBlue,
                                background: colorConfigs.btnStyle.color,
                                "&: hover": {
                                    color: colorConfigs.btnColor.colorDarkBlue,
                                    background: colorConfigs.btnStyle.color,
                                },
                            }}
                        >
                            {"Back"}
                        </Button>}

                        <Box display={"flex"}>
                            <Button
                                type="button"
                                variant="outlined"
                                endIcon={<ArrowForwardIcon />}
                                className="cm-btn-style"
                                sx={{
                                    mx:2,
                                    display: "flex",
                                    justifyContent: "end",
                                    color: colorConfigs.btnStyle.color,
                                    background: colorConfigs.btnColor.bgColorLightBlue,
                                    marginTop:2,
                                    "&: hover": {
                                        color: colorConfigs.btnStyle.color,
                                        background: colorConfigs.btnColor.colorDarkBlue,
                                    },
                                }}
                                onClick={handleReviewButtonClick}
                            >
                                {t("Review")}
                            </Button>
                            {currentStep === 4 && <Button
                                type="submit"
                                variant="contained"
                                endIcon={<ArrowForwardIcon />}
                                className="cm-btn-style"
                                sx={{
                                    display: "flex",
                                    justifyContent: "end",
                                    color: colorConfigs.btnStyle.color,
                                    background: colorConfigs.btnColor.bgColorLightBlue,
                                    "&: hover": {
                                        color: colorConfigs.btnStyle.color,
                                        background: colorConfigs.btnColor.colorDarkBlue,
                                    },
                                }}
                            >
                                {t("Continue")}
                            </Button>}
                        </Box>

                    </Box>
                </form>
            </Box>
        </>
    )



}


export default ContactDetailsForm;
